import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Utils } from '../../shared/utils';

import * as d3 from 'd3';

export class DoughnutDataModel {
  constructor(public value: number,
              public id?: string,
              public color?: string) { }
}

const radius = 22;
const totalSide = 50;

@Component({
  selector: 'mpro-doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.scss']
})
export class DoughnutChartComponent implements AfterViewInit, OnChanges {
  @Input() public data: DoughnutDataModel[] = [];
  @Input() public colors: string[] = [];
  @Input() public selectedSegment?: string;

  @Output() public segmentSelected: EventEmitter<string> = new EventEmitter<string>();
  @Output() public segmentDeselected: EventEmitter<string> = new EventEmitter<string>();

  public chartId: string;
  public idToColor: Map<string, string> = new Map();
  public selected: string[] = [];

  private svg: any;

  // TODO implement onChanges to be able to redraw chart
  constructor() {
    this.chartId = Utils.generateId(5);
  }

  public ngAfterViewInit() {
    this.createSvg();
    this.drawChart();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.data?.firstChange) {
      return;
    }

    d3.selectAll(`#${this.chartId} svg g > *`).remove();
    this.drawChart();
    this.selectSegment();
  }

  private createSvg(): void {
    this.svg = d3
      .select(`figure#${this.chartId}`)
      .append("svg")
      .attr("width", '100%')
      .attr("height", '100%')
      .append("g")
      .attr(
        "transform",
        `translate(${totalSide / 2}, ${totalSide / 2})`
      );
  }

  private drawChart(): void {
    const pie = d3.pie<any>().value((d: any) => d.value).sort(null);
    const data_ready = pie(this.data);

    let arc = d3
      .arc()
      .innerRadius(9)
      .outerRadius(radius);

    let arcOver = d3
      .arc()
      .innerRadius(8.5)
      .outerRadius(radius + 0.5)

    let arcClick = d3
      .arc()
      .innerRadius(8.8)
      .outerRadius(radius + 0.8)


    // store this in a var, because 'this' in the d3 callbacks points to the svg element
    var self = this;

    this.svg
      .selectAll("pieces")
      .data(data_ready)
      .enter()
      .append("path")
      .attr('id', (node: any) => node.data.id ? node.data.id : Utils.generateId(5))
      .attr("d", arc)
      .attr("fill", (node: any, idx: number, array: any[]) => {
        let c = node.data.color ? node.data.color : self.colors[idx];
        self.idToColor.set(array[idx].id, c);
        return c;
      })
      .attr("stroke", "white")
      .style("stroke-width", "3px");

      // the code below is not deleted in case making the chart clickable is required in the future

      // .on('click', (d: any) => {
      //   if (self.selected.includes(d.target.id)) {
      //     // deselect
      //     self.selected.splice(self.selected.indexOf(d.target.id), 1);
      //     self.segmentDeselected.emit(d.target.id);
      //     let removed = d3.select(d.target)
      //       // put on bottom; if neighbouring segment is selected it should be on top
      //       .lower()
      //       .attr("d", <any>arc)
      //       .style("stroke-width", "3px");
      //     if (self.selected.length) {
      //       removed.attr('fill-opacity', '40%');
      //     } else {
      //       d3.selectAll(`#${self.chartId} path`)
      //         .attr('fill-opacity', '100%');
      //     }
      //   } else {
      //     // select
      //     self.selected.push(d.target.id);
      //     self.segmentSelected.emit(d.target.id);
      //     let cssQueryNotSelected = '#' + self.chartId + ' path' + self.selected.map(id => `:not(#${id})`).join('');
      //     d3.selectAll(cssQueryNotSelected).attr('fill-opacity', '40%');
      //     d3.select(d.target)
      //       // put on top so that neighboring segments' stroke does not overlap
      //       .raise()
      //       .attr('fill', (data, idx, array) => {
      //         return self.idToColor.get(array[0].id) || null;
      //       })
      //       .style("stroke-width", "0px")
      //       .attr("d", <any>arcClick);
      //   }
      // })
      // .on("mouseover", (d: any) => {
      //   if (self.selected.includes(d.target.id)) {
      //     return;
      //   }

      //   d3.select(d.target)
      //     .attr('fill', (data: any, idx: number, array: any) => {
      //       return self.idToColor.get(array[0].id) || null;
      //     })
      //     .attr('fill-opacity', '80%')
      //     .style("stroke-width", "2px")
      //     .attr("d", <any>arcOver);
      // })
      // .on("mouseout", (d: any) => {
      //   if (self.selected.includes(d.target.id)) {
      //     return;
      //   }

      //   let segement = d3.select(d.target)
      //     .style("stroke-width", "3px")
      //     .attr("d", <any>arc);

      //   let opacity = (self.selected.length ? '40' : '100') + '%'
      //   segement.attr('fill-opacity', opacity);
      // });

    this.svg
      .selectAll("pieces")
      .data(pie(this.data))
      .enter()
  }

  private selectSegment() {

    this.selected = [];

    if (!this.selectedSegment) {
      let arc = d3
        .arc()
        .innerRadius(9)
        .outerRadius(radius);

      d3.selectAll(`#${this.chartId} path`)
        .attr('fill-opacity', '100%')
        .attr("d", <any>arc)
        .style("stroke-width", "3px");
    } else {
      // select
      let arcClick = d3
      .arc()
      .innerRadius(8.8)
      .outerRadius(radius + 0.8)

      this.selected.push(this.selectedSegment);
      let cssQueryNotSelected = '#' + this.chartId + ' path' + this.selected.map(id => `:not(#${id})`).join('');
      d3.selectAll(cssQueryNotSelected).attr('fill-opacity', '40%');
      d3.select(`#${this.selectedSegment}`)
        // put on top so that neighboring segments' stroke does not overlap
        .raise()
        .attr('fill', (data, idx, array) => {
          return this.idToColor.get(this.selectedSegment || '') || null;
        })
        .style("stroke-width", "0px")
        .attr("d", <any>arcClick);
    }
  }

}
